import React from 'react';
import { Popover } from 'antd';
import CurrentDevice from 'current-device';
import Utils from '@/utils/utils';

export const getThreeDayTrialPlatform = () => {
  if (CurrentDevice.mobile()) {
    return 'win';
  }

  const globalUserStore =
    typeof window !== 'undefined' ? window.userStore : null;
  const os = ((globalUserStore && globalUserStore.os) || '').toLowerCase();

  if (os.indexOf('mac') > -1) {
    return 'mac';
  }
  if (os.indexOf('win') > -1 || os.indexOf('windows') > -1) {
    return 'win';
  }

  return Utils.getSystemType() === 'Mac' ? 'mac' : 'win';
};

const QuestionIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_4672_2580)'>
      <path
        d='M7.99967 14.6673C9.84061 14.6673 11.5073 13.9211 12.7137 12.7147C13.9201 11.5083 14.6663 9.84158 14.6663 8.00065C14.6663 6.15972 13.9201 4.49305 12.7137 3.2866C11.5073 2.08018 9.84061 1.33398 7.99967 1.33398C6.15874 1.33398 4.49207 2.08018 3.28563 3.2866C2.0792 4.49305 1.33301 6.15972 1.33301 8.00065C1.33301 9.84158 2.0792 11.5083 3.28563 12.7147C4.49207 13.9211 6.15874 14.6673 7.99967 14.6673Z'
        stroke='#7C7C80'
        strokeLinejoin='round'
      />
      <path
        d='M8 9.54232V8.20898C9.10457 8.20898 10 7.31355 10 6.20898C10 5.10442 9.10457 4.20898 8 4.20898C6.89543 4.20898 6 5.10442 6 6.20898'
        stroke='#7C7C80'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.00033 12.5417C8.46056 12.5417 8.83366 12.1686 8.83366 11.7083C8.83366 11.2481 8.46056 10.875 8.00033 10.875C7.54009 10.875 7.16699 11.2481 7.16699 11.7083C7.16699 12.1686 7.54009 12.5417 8.00033 12.5417Z'
        fill='#7C7C80'
      />
    </g>
    <defs>
      <clipPath id='clip0_4672_2580'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const ThreeDayTrial = ({ checked = true, onChange }) => {
  const platform = getThreeDayTrialPlatform();
  const productName =
    platform === 'mac' ? 'HitPaw Ultra For Mac' : 'HitPaw Ultra For Windows';

  const handleCheckedChange = (event) => {
    if (onChange) {
      onChange(event.target.checked);
    }
  };

  const openCancel = () => {
    window.open(
      'https://www.hitpaw.com/support/how-to-cancel-subscription.html',
      '_blank'
    );
  };

  const popoverContent = (
    <div className='tip_content'>
      Along with purchasing HitPaw Online Ultra, you are eligible for a 3-day trial of HitPaw Ultra Desktop. Subsequent automatic renewal will be monthly at US$19.95 (50% ОFF). You can{' '}
      <span className='cancel_text' onClick={openCancel}>
        cancel
      </span>{' '}
      it any time before renewal.
    </div>
  );

  return (
    <div className='three-day-trial'>
      <div className='three-day-trial-header'>
        <input
          className='trial-checkbox'
          type='checkbox'
          checked={checked}
          aria-label='3-Day-Trial'
          onChange={handleCheckedChange}
        />
        <span className='trial-product'>HitPaw Ultra Desktop</span>
        <span className='trial-badge'>3-Day-Trial</span>
      </div>

      <div className='three-day-trial-description'>
        <span>
          Try 3 days for free, then auto-renew at US$19.95/month (50% off). You can cancel it anytime.
        </span>
        <Popover
          overlayClassName='trial-popover'
          placement='top'
          content={popoverContent}
        >
          <span className='trial-tooltip'>
            <QuestionIcon />
          </span>
        </Popover>
      </div>
    </div>
  );
};

export default ThreeDayTrial;
